import * as React from "react";
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Container,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../assets/Images/Logo.png";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { text: "Home", section: "home" },
  { text: "About", section: "about" },
  { text: "Services", section: "services" },
  { text: "DBS-Search", href: "/login" },
  { text: "Contact Us", section: "contact" },
];

const ResponsiveAppBar = ({ scrollToSection }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavClick = (link) => {
    if (link.section) {
      if (location.pathname === "/") {
        // Already on home, scroll directly
        scrollToSection && scrollToSection(link.section);
      } else {
        // Navigate to home with section info
        navigate(`/#${link.section}`);
      }
    } else if (link.href) {
      navigate(link.href);
    }
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{ bgcolor: "white", boxShadow: "none", paddingY: 1 }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: "space-between" }}>
            {/* Logo */}
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <img
                alt="logo"
                src={Logo}
                style={{ height: "50px", objectFit: "contain" }}
              />
            </Typography>

            {/* Desktop Menu */}
            {!isMobile && (
              <Box>
                {navLinks.map((link, index) => (
                  <Button
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link);
                    }}
                    sx={{
                      color: "#333",
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "16px",
                      mx: 2,
                      "&:hover": { backgroundColor: "#b4d78d" },
                    }}
                  >
                    {link.text}
                  </Button>
                ))}
              </Box>
            )}

            {/* Mobile Menu */}
            {isMobile && (
              <>
                <IconButton onClick={handleMenuOpen}>
                  <MenuIcon sx={{ color: "#333" }} />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: {
                      backgroundColor: "#c6db8c",
                      width: "auto",
                      minWidth: "150px",
                    },
                  }}
                >
                  {navLinks.map((link, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        handleMenuClose();
                        handleNavClick(link);
                      }}
                    >
                      {link.text}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default ResponsiveAppBar;
